import React from "react";
import FormInput from "../../../components/common/FormInput/FormInput";
import '../auth.css';
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const Forgetpassword = () => {
  const navigate = useNavigate();

  const LoginAuth = (e) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <div className="login-wrapper">
      <form className="form-conatiner" onSubmit={LoginAuth}>
        <img src="/Images/magnus-logo.png" alt="logo" />
        <Row>
          <Col xs={12} >
            <label className="form-label">Password</label>
            <FormInput placeholder="Enter password" type="password" />
          </Col>
          <Col xs={12}>
            <button type="submit" className="login-btn">
              Forget Password
            </button>
          </Col>

<Col xs={12}>
  <Link to="/login" className="forgetpass mt-2">
              sign In
            </Link>
</Col>

        </Row>
      </form>
    </div>
  );
};

export default Forgetpassword;